var render = function render(){var _vm=this,_c=_vm._self._c;return (
    (_vm.field.type === 'group' && _vm.isGroupVisible(_vm.field)) ||
    _vm.bulkDelete ||
    (_vm.configVisibility['bulkEdit'] &&
      _vm.configVisibility['bulkEdit'][_vm.field.category || _vm.category] &&
      _vm.configVisibility['bulkEdit'][_vm.field.category || _vm.category][_vm.field.id])
  )?_c('div',{staticClass:"field",class:[
    _vm.hasValue({
      id: _vm.field.id,
      category: _vm.field.category || _vm.category,
    }) && 'has-value',
    _vm.bulkDelete ? 'bulk-delete' : 'bulk-edit',
  ]},[_c('div',{staticClass:"question",attrs:{"id":_vm.field.id}},[(_vm.isChecklist(_vm.field))?_c('div',{staticClass:"checklist"},[(_vm.checklistLabel(_vm.field))?_c('p',[_vm._v("\n        "+_vm._s(_vm.checklistLabel(_vm.field))+"\n      ")]):_vm._e(),_vm._l((_vm.checklistItems(_vm.field)),function(groupField){return _c('div',{key:_vm.getFieldData(groupField.id)['FieldId']},[_c('bulkDeleteCheckbox',{attrs:{"label":_vm.getFieldValue('label', groupField.id),"disabled":_vm.getFieldValue('disabled', groupField.id),"fields":[
            {
              id: groupField.id,
              category: groupField.category || _vm.category,
              parentField: groupField.parentField || _vm.parentField,
              type:
                _vm.getFieldType({
                  id: groupField.id,
                  category: groupField.category || _vm.category,
                }) || '',
            },
          ]}})],1)})],2):[(_vm.bulkDelete)?_c('bulkDeleteCheckbox',{attrs:{"fields":[
          {
            id: _vm.field.id,
            category: _vm.field.category || _vm.category,
            parentField: _vm.field.parentField || _vm.parentField,
            type:
              _vm.getFieldType({
                id: _vm.field.id,
                category: _vm.field.category || _vm.category,
              }) || '',
          },
        ]}}):_vm._e(),_c('p',[_vm._v("\n        "+_vm._s(_vm.getFieldValue("label", _vm.field.id) || _vm.field.label || _vm.field.id)+"\n        "),_c('tooltip',{attrs:{"text":_vm.getFieldValue('tooltip', _vm.field.id)}}),(_vm.getFieldValue('helpContent', _vm.field.id))?_c('helpIcon',{attrs:{"content":_vm.getFieldValue('helpContent', _vm.field.id)}}):_vm._e()],1)]],2),(!_vm.bulkDelete)?_c('div',{staticClass:"answer"},[(_vm.field.type === 'group')?_c('group',{attrs:{"category":_vm.field.category || _vm.category,"field":_vm.field,"parentField":_vm.parentField,"id":_vm.bulkDelete ? 'bulkDelete' : 'bulkEdit'}}):(_vm.field.type === 'contentGroup')?_c('contentGroup',{staticClass:"body-2 content-group",attrs:{"category":_vm.field.category || _vm.category,"field":_vm.field,"parentField":_vm.parentField,"id":_vm.bulkDelete ? 'bulkDelete' : 'bulkEdit'}}):_c('configField',{attrs:{"category":_vm.field.category || _vm.category,"field":_vm.getFieldData({
          id: _vm.field.id,
          category: _vm.field.category || _vm.category,
        }),"value":_vm.getConfigValue({
          id: _vm.field.id,
          category: _vm.field.category || _vm.category,
        }),"layout":_vm.field.layout,"parentField":_vm.parentField,"id":_vm.bulkDelete ? 'bulkDelete' : 'bulkEdit',"hideLabel":"","hideTooltip":"","emitSetConfig":""},on:{"setConfigValue":_vm.setConfigValue,"unsetConfigValue":_vm.unsetConfigValue}})],1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }